<template>
  <div>
    <PageTitle title="New Sales" :backBtn="true" />

    <v-container fluid class="lighten-12">
      <GeneralDetails
        @setDate="getDate"
        @setCustomer="getCustomer"
        @setShop="getShop"
        :sale="DefSaleDetails"
      />

      <ProductList
        :productIsVisible="isProductVisible"
        :sale="sale"
        :errormsgs="errormsgs"
        :shopId="Shop_id"
      />
      <salebill
        ref="CallingBill"
        :ProductDatas="setProductDatas"
        :PaymentDetails="setPaymentDetails"
        :SaleDetails="setSaleDetails"
        v-show="false"
      />

      <Payment
        :drawer="draweropen"
        @setPaymentDetails="getPayement"
        :Paymentclicked="isButtondisabled"
        :Customer="customer"
      />
      <v-col cols="12" class="text-right mt-3 pa-0">
        <v-btn
          depressed
          small
          class="text-white btn_blue btn_medium w-100"
          @click.stop="openPaymentSection"
          >Payment</v-btn
        >
      </v-col>
    </v-container>
  </div>
</template>
<script>
import GeneralDetails from './common.vue';
import ProductList from './Products.vue';
import Payment from './Payment.vue';
import { BillDecorator } from '@/models/BillModel';
import moment from 'moment';
import salebill from '@/components/shared/SalesBill.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    GeneralDetails,
    ProductList,
    Payment,
    salebill,
  },
  created() {
    if (this.saleQuotation) {
      this.DefSaleDetails = {
        shop_id: this.saleDetails.shop_id,
        customer_id: this.saleDetails.customer_id,
        date: moment(new Date()).format('YYYY-MM-DD'),
      };
    }
  },
  computed: {
    ...mapGetters(['GetTotalAmount']),
    ...mapState(['StoredProducts']),
    ...mapState(['saleQuotation']),
    ...mapState(['saleDetails']),
  },
  data: () => ({
    draweropen: null,
    errormsgs: null,
    setProductDatas: [],
    setPaymentDetails: [],
    setSaleDetails: [],
    date: null,
    firstTime: false,
    isButtondisabled: false,
    isProductVisible: false,
    customer: 1,
    Shop_id: 1,
    DefSaleDetails: {
      shop_id: 1,
      customer_id: 1,
      date: moment(new Date()).format('YYYY-MM-DD'),
    },
  }),
  destroyed() {
    this.$store.commit('SUCCESS_SALE_CLEAR_DATAS', {});
    this.$store.commit('UPDATE_SALES_QUOTATION', false);
  },
  methods: {
    openPaymentSection() {
      if (!this.StoredProducts[0].productid) {
        this.errormsgs = 'Please Choose the product';
        setTimeout(() => {
          this.isProductVisible = true;
        }, 400);
      } else if (!this.StoredProducts[0].batch_id) {
        this.errormsgs = 'Please Choose the product batch';
        setTimeout(() => {
          this.isProductVisible = true;
        }, 400);
      } else if (!this.StoredProducts[0].unit_id) {
        this.errormsgs = 'Please Choose the product unit';
        setTimeout(() => {
          this.isProductVisible = true;
        }, 400);
      } else {
        this.isProductVisible = false;
        this.SetTotalAmount(this.GetTotalAmount);
        this.firstTime = true;
        this.draweropen = !this.draweropen;
        if (this.draweropen == false) {
          this.draweropen = true;
        }
      }
    },

    SetTotalAmount(newValue) {
      this.$store.commit('UPDATE_TOTAL_AMOUNT', {
        amount: newValue,
      });
    },
    getDate(value) {
      this.date = value;
    },
    getCustomer(value) {
      this.customer = value;
    },
    getShop(value) {
      this.$store.commit('UPDATE_SHOP_FILTERID', value);
      this.Shop_id = value;
    },

    getPayement(data) {
      this.$confirm('Do you want to Confirm this sale?').then((res) => {
        if (res) {
          let self = this;
          let credential = data;
          credential.customer_id = this.DefSaleDetails.customer_id;
          credential.date = this.DefSaleDetails.date;
          credential.shop_id = this.DefSaleDetails.shop_id;
          this.isButtondisabled = true;
          this.$store
            .dispatch('createSale', new BillDecorator().toSell(credential))
            .then((res) => {
              this.setProductDatas = res.data.saleItems;
              this.setPaymentDetails = res.data.payments;
              this.setSaleDetails = res.data;
              setTimeout(() => {
                this.$refs.CallingBill.print();
              }, 1000);
              this.$store.commit('SUCCESS_SALE_CLEAR_DATAS', {});
              this.$toast.success('Sale created successfully');
              this.isButtondisabled = false;

              setTimeout(() => {
                this.$router.push('/sales');
              }, 2000);

              this.firstTime = false;
            })
            .catch((err) => {
              if (err.data) {
                this.errormsgs = err.data;
                setTimeout(() => {
                  this.isProductVisible = true;
                }, 400);
              }

              this.$toast.error('Failed to create sale');
              this.isButtondisabled = false;
              setTimeout(() => {
                this.isButtondisabled = false;
              }, 2000);
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>
